/**
 * Provides "latest wins" cancellation for a sequence of async calls. Each call to
 * {@link next} aborts the previous signal and returns a fresh one, so only the most
 * recent invocation's result should be used.
 */
export function useLatestRequest(): {
  /** Abort the previous signal and return a fresh one for the next call. */
  next: () => AbortSignal;
  /** True if the given signal has not been superseded by a newer call. */
  isCurrent: (signal: AbortSignal) => boolean;
} {
  let active: AbortController | null = null;

  const next = (): AbortSignal => {
    active?.abort();
    active = new AbortController();
    return active.signal;
  };

  const isCurrent = (signal: AbortSignal): boolean => !signal.aborted;

  return { next, isCurrent };
}
